// extracted by mini-css-extract-plugin
module.exports = {"stars":"_3bQihm","star":"_3XQqMq","number":"_3bIRPN","clickable":"e_kKrd"};